import { Formation, Position } from '../types';

export const formationPitchPositions = [
  // 7x7
  // 2-3-1
  {
    formation: Formation.TwoThreeOne,
    positions: [
      {
        x: '50%',
        y: '90%',
        position: Position.GK,
      },
      // Defence
      {
        x: '35%',
        y: '75%',
        position: Position.LB,
      },
      {
        x: '65%',
        y: '75%',
        position: Position.RB,
      },
      // Midfield
      {
        x: '50%',
        y: '60%',
        position: Position.CM,
      },
      {
        x: '20%',
        y: '50%',
        position: Position.LW,
      },
      {
        x: '80%',
        y: '50%',
        position: Position.RW,
      },
      // Attack
      {
        x: '50%',
        y: '35%',
        position: Position.ST,
      },
    ],
  },
  // 3-2-1
  {
    formation: Formation.ThreeTwoOne,
    positions: [
      {
        x: '50%',
        y: '90%',
        position: Position.GK,
      },
      // Defence
      {
        x: '20%',
        y: '70%',
        position: Position.LB,
      },
      {
        x: '80%',
        y: '70%',
        position: Position.RB,
      },
      {
        x: '50%',
        y: '75%',
        position: Position.CB,
      },
      // Midfield
      {
        x: '35%',
        y: '50%',
        position: Position.LW,
      },
      {
        x: '65%',
        y: '50%',
        position: Position.RW,
      },
      // Attack
      {
        x: '50%',
        y: '35%',
        position: Position.ST,
      },
    ],
  },
  // 2-2-2
  {
    formation: Formation.TwoTwoTwo,
    positions: [
      {
        x: '50%',
        y: '90%',
        position: Position.GK,
      },
      // Defence
      {
        x: '35%',
        y: '75%',
        position: Position.LB,
      },
      {
        x: '65%',
        y: '75%',
        position: Position.RB,
      },
      // Midfield
      {
        x: '35%',
        y: '55%',
        position: Position.LW,
      },
      {
        x: '65%',
        y: '55%',
        position: Position.RW,
      },
      // Attack
      {
        x: '35%',
        y: '35%',
        position: Position.ST,
      },
      {
        x: '65%',
        y: '35%',
        position: Position.CF,
      },
    ],
  },
  // 8x8
  // 3-3-1
  {
    formation: Formation.ThreeThreeOne,
    positions: [
      {
        x: '50%',
        y: '90%',
        position: Position.GK,
      },
      // Defence
      {
        x: '20%',
        y: '70%',
        position: Position.LB,
      },
      {
        x: '80%',
        y: '70%',
        position: Position.RB,
      },
      {
        x: '50%',
        y: '75%',
        position: Position.CB,
      },
      // Midfield
      {
        x: '50%',
        y: '55%',
        position: Position.CM,
      },
      {
        x: '20%',
        y: '45%',
        position: Position.LW,
      },
      {
        x: '80%',
        y: '45%',
        position: Position.RW,
      },
      // Attack
      {
        x: '50%',
        y: '30%',
        position: Position.ST,
      },
    ],
  },
  // 3-2-2
  {
    formation: Formation.ThreeTwoTwo,
    positions: [
      {
        x: '50%',
        y: '90%',
        position: Position.GK,
      },
      // Defence
      {
        x: '20%',
        y: '70%',
        position: Position.LB,
      },
      {
        x: '80%',
        y: '70%',
        position: Position.RB,
      },
      {
        x: '50%',
        y: '75%',
        position: Position.CB,
      },
      // Midfield
      {
        x: '35%',
        y: '55%',
        position: Position.LW,
      },
      {
        x: '65%',
        y: '55%',
        position: Position.RW,
      },
      // Attack
      {
        x: '50%',
        y: '40%',
        position: Position.CF,
      },
      {
        x: '50%',
        y: '25%',
        position: Position.ST,
      },
    ],
  },
  // 2-3-2
  {
    formation: Formation.TwoThreeTwo,
    positions: [
      {
        x: '50%',
        y: '90%',
        position: Position.GK,
      },
      // Defence
      {
        x: '35%',
        y: '75%',
        position: Position.LB,
      },
      {
        x: '65%',
        y: '75%',
        position: Position.RB,
      },
      // Midfield
      {
        x: '50%',
        y: '60%',
        position: Position.CM,
      },
      {
        x: '20%',
        y: '50%',
        position: Position.LW,
      },
      {
        x: '80%',
        y: '50%',
        position: Position.RW,
      },
      // Attack
      {
        x: '50%',
        y: '40%',
        position: Position.CF,
      },
      {
        x: '50%',
        y: '25%',
        position: Position.ST,
      },
    ],
  },
  // 2-4-1
  {
    formation: Formation.TwoFourOne,
    positions: [
      {
        x: '50%',
        y: '90%',
        position: Position.GK,
      },
      // Defence
      {
        x: '35%',
        y: '75%',
        position: Position.LB,
      },
      {
        x: '65%',
        y: '75%',
        position: Position.RB,
      },
      // Midfield
      {
        x: '35%',
        y: '55%',
        position: Position.CM,
      },
      {
        x: '65%',
        y: '55%',
        position: Position.DM,
      },
      // Midfield
      {
        x: '20%',
        y: '40%',
        position: Position.LW,
      },
      {
        x: '80%',
        y: '40%',
        position: Position.RW,
      },
      // Attack
      {
        x: '50%',
        y: '25%',
        position: Position.ST,
      },
    ],
  },
  // 9x9
  // 3-3-2
  {
    formation: Formation.ThreeThreeTwo,
    positions: [
      {
        x: '50%',
        y: '90%',
        position: Position.GK,
      },
      // Defence
      {
        x: '20%',
        y: '70%',
        position: Position.LB,
      },
      {
        x: '80%',
        y: '70%',
        position: Position.RB,
      },
      {
        x: '50%',
        y: '75%',
        position: Position.CB,
      },
      // Midfield
      {
        x: '50%',
        y: '55%',
        position: Position.CM,
      },
      {
        x: '25%',
        y: '50%',
        position: Position.LW,
      },
      {
        x: '75%',
        y: '50%',
        position: Position.RW,
      },
      // Attack
      {
        x: '50%',
        y: '40%',
        position: Position.CF,
      },
      {
        x: '50%',
        y: '25%',
        position: Position.ST,
      },
    ],
  },
  // 3-2-3
  {
    formation: Formation.ThreeTwoThree,
    positions: [
      {
        x: '50%',
        y: '90%',
        position: Position.GK,
      },
      // Defence
      {
        x: '20%',
        y: '70%',
        position: Position.LB,
      },
      {
        x: '80%',
        y: '70%',
        position: Position.RB,
      },
      {
        x: '50%',
        y: '75%',
        position: Position.CB,
      },
      // Midfield
      {
        x: '30%',
        y: '50%',
        position: Position.LW,
      },
      {
        x: '70%',
        y: '50%',
        position: Position.RW,
      },
      // Attack
      {
        x: '30%',
        y: '35%',
        position: Position.LF,
      },
      {
        x: '70%',
        y: '35%',
        position: Position.RF,
      },
      {
        x: '50%',
        y: '25%',
        position: Position.ST,
      },
    ],
  },
  // 3-4-1
  {
    formation: Formation.ThreeFourOne,
    positions: [
      {
        x: '50%',
        y: '90%',
        position: Position.GK,
      },
      // Defence
      {
        x: '20%',
        y: '70%',
        position: Position.LB,
      },
      {
        x: '80%',
        y: '70%',
        position: Position.RB,
      },
      {
        x: '50%',
        y: '75%',
        position: Position.CB,
      },
      // Midfield
      {
        x: '25%',
        y: '50%',
        position: Position.LW,
      },
      {
        x: '75%',
        y: '50%',
        position: Position.RW,
      },
      {
        x: '50%',
        y: '60%',
        position: Position.DM,
      },
      {
        x: '50%',
        y: '40%',
        position: Position.AM,
      },
      // Attack
      {
        x: '50%',
        y: '25%',
        position: Position.ST,
      },
    ],
  },
];
